import axios from 'axios'
import store from '@/store'

const audiobooksApi = axios.create({
  baseURL: '',
  headers: { Accept: 'application/json' },
})

audiobooksApi.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

audiobooksApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return audiobooksApi(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  },
)

export default {
  getAllPost() {
    return audiobooksApi.get('/api/audiobooks/post')
  },
  getPostByID(id) {
    return audiobooksApi.get(`/api/audiobooks/post/${id}`)
  },
  addPost(formData) {
    return audiobooksApi.post('/api/audiobooks/post/', formData)
  },
  updatePost(id, formData) {
    return audiobooksApi.patch(`/api/audiobooks/post/${id}`, formData)
  },
  deletePost(id) {
    return audiobooksApi.delete(`/api/audiobooks/post/${id}`)
  },
  toggleFavorite(id) {
    return audiobooksApi.patch(`/api/audiobooks/post/${id}/favorite`)
  },
  moveToCollection(id) {
    return audiobooksApi.patch(`/api/audiobooks/post/${id}/collection`)
  },
  search(search) {
    return audiobooksApi.get('/api/audiobooks/search', { params: { search } })
  },
}
